/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';

export default function SortData(props) {
  const [show, setShow] = useState(true);
  return (
    <div
      className={`border ${props.fullWidth ? '' : 'max-width-285'} mt-4 ${props.className || ''}`.trim()}
      id="duration"
    >
      <p className="font-size-16 font-weight-600">
        {props.title}{' '}
        <i
          className={`bi p-2 ${show ? 'bi-chevron-up' : 'bi-chevron-down'} display-right font-size-12 cursor-pointer`}
          onClick={() => setShow(!show)}
        />
      </p>
      {show ? (
        <div className="mt-5">
          {props.data
            ? props.data.map((dat, index) => {
                return (
                  <div className={`display-flex mt-4 ${isMobile ? 'mx-2' : ''}`} key={index}>
                    <>
                      <input
                        id={dat.id}
                        type="radio"
                        checked={props.sort === dat.id}
                        className="input-checkbox"
                        onChange={() => props.handleFilter(dat.id)}
                      />
                      <label htmlFor={dat.id} className="margin-left-20 font-size-14 cursor-pointer">
                        {' '}
                        {dat.name}
                      </label>
                    </>
                  </div>
                );
              })
            : ''}
          {/* <p className="mt-4 font-size-14 text-primary font-weight-500">Show More</p> */}
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
